import React from 'react';
import PropTypes from 'prop-types';
import { ZCDIcon, ZCDIconColor, ZCDTooltip } from '@zencity/common-ui';
import classNames from 'classnames';

function TooltipHeader(props) {
  const { title, tooltipText, className } = props;

  return (
    <div className={classNames('engage-tooltip-header', className)}>
      <h4>{title}</h4>
      <div className="engage-tooltip-header__tooltip">
        <ZCDTooltip text={tooltipText}>
          <div>
            <ZCDIcon name="info" color={ZCDIconColor.BLUE} />
          </div>
        </ZCDTooltip>
      </div>
    </div>
  );
}

TooltipHeader.propTypes = {
  title: PropTypes.string.isRequired,
  tooltipText: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

export default TooltipHeader;
